var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFlighttrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 19,
    viewBox: "0 0 156 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 9,
    fill: "#D0D0D0",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.0001,
    cy: 10,
    r: 6.42857,
    fill: "#D0D0D0",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99997,
    cy: 10,
    r: 3.85714,
    fill: "#D0D0D0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 10,
    r: 9,
    fill: "#D0D0D0",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 10,
    r: 6.42857,
    fill: "#D0D0D0",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 10,
    r: 3.85714,
    fill: "#D0D0D0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 9.5,
    x2: 66.5,
    y2: 9.5,
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeDasharray: "5 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 89.5,
    y1: 9.5,
    x2: 133.5,
    y2: 9.5,
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeDasharray: "5 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 9.4C87 10.12 86.37 10.75 85.65 10.75H80.7L76.2 17.95H74.4L76.65 10.75H71.7L70.35 12.55H69L69.9 9.4L69 6.25H70.35L71.7 8.05H76.65L74.4 0.850004H76.2L80.7 8.05H85.65C86.37 8.05 87 8.68 87 9.4Z",
    fill: "#0064D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlighttrip);
export default __webpack_public_path__ + "static/media/ic_flighttrip.db1a7cb0fb04e9f7ccb5db32dbbde5eb.svg";
export { ForwardRef as ReactComponent };